import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
// import { SwUpdate } from '@angular/service-worker';
import { Meta, Title } from '@angular/platform-browser';
import { environment } from '../environments/environment';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  env: any = environment;
  update = false;
  theme = '';

  constructor(
    @Inject(DOCUMENT) public document: Document,
    // updates: SwUpdate,
    private titleService: Title,
    private metaService: Meta // public http: HttpClient
  ) {
    // updates.available.subscribe((event: any) => {
    //   this.update = true;
    //   updates.activateUpdate().then(() => document.location.reload());
    // });
    const window: any = this.document.defaultView;
    const host = window.location.hostname;
    this.setDynamicStyle(host);
  }

  async setDynamicStyle(host: any) {
    const index = this.env.hosts.findIndex((e: any) => host.includes(e.domain));
    this.env.host = this.env.hosts[index];
    // console.log(this.env.host);
    const name =
      this.env.host.name.charAt(0).toUpperCase() + this.env.host.name.slice(1);
    this.env.app = name;
    this.env.baseUrl = this.env.host.baseUrl;
    this.env.socketUrl = this.env.host.socketUrl;

    this.titleService.setTitle(name);

    this.theme =
      localStorage.getItem(`${this.env.app}_theme`) ===
      this.env.theme.lightTheme
        ? this.env.theme.lightTheme
        : this.env.theme.darkTheme;

    const head: any = this.document.getElementsByTagName('head')[0];
    const style: any = this.document.createElement('style');
    style.id = 'theme';
    style.innerHTML = this.env.host ? this.env.host[this.theme] : '';
    head.appendChild(style);

    this.metaService.updateTag({
      name: this.env.host.meta.name,
      content: this.env.host.meta.content,
    });

    // this.metaService.addTag({
    //   name: this.env.host.meta.name,
    //   content: this.env.host.meta.content,
    // });

    localStorage.setItem(`${this.env.app}_theme`, this.theme);

    // this.getMinifest();
  }
}
